import { String, Number, Object, Static, Record, Optional } from '@sinclair/typebox';

import { CalendarAssociationsMatrix } from './associationsMatrix';

export type DateFares = Static<typeof DateFares>;
export const DateFares = Record(String(), Number());

export type AssociatedDate = Static<typeof AssociatedDate>;
const AssociatedDate = Record(String(), Number());

export type CalendarDate = Static<typeof CalendarDate>;
const CalendarDate = Record(
  String(),
  Object({
    price: Number(),
    // availableSeats: Number(),
    associatedDates: Optional(AssociatedDate),
  })
);

export type CalendarSearchResponse = Static<typeof CalendarSearchResponse>;
export const CalendarSearchResponse = Object({
  outbound: Object({
    fares: DateFares,
    associations: Optional(CalendarAssociationsMatrix),
  }),
  inbound: Optional(
    Object({
      fares: DateFares,
      associations: Optional(CalendarAssociationsMatrix),
    })
  ),
});
